module.exports = __webpack_public_path__ + "static/media/font-case.11eb4efc.svg";